
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SectionItem from './heroSectionItem/sectionItem.vue'
import SectionItemSecond from './heroSectionItem/sectionItemSecond.vue'
import SectionItemThird from './heroSectionItem/sectionItemThird.vue'
import Dots from './dots/index.vue'
import { HeroSectionConfig } from '@xt/client/utils/home/index'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    NewSwiper,
    SectionItem,
    SectionItemSecond,
    SectionItemThird,
    Dots
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    dotScrollTo: (index: number) => void
  }
  autoplayDuration: number = 7000
  activeIndex: number = 0

  get JsonData() {
    return this.$store.$homeV2.dataSource?.banner
  }

  // 获取轮播组件
  getBannerComponent(temp: string): string {
    return HeroSectionConfig[temp]
  }

  // 指示点滚动事件
  handleScrollTo(index) {
    if (!this.swiper) return
    this.swiper.dotScrollTo(index)
  }

  // 轮播切换事件
  handleChange(index: number) {
    if (this.activeIndex === index) return
    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
